import { OnInit, Component, Inject } from '@angular/core';
import { NotificationToastService } from '../../../services/notification-toast.service';
import { MatDialogRef, MAT_DIALOG_DATA, MatTableDataSource } from '@angular/material';
import { StudyReportService } from '../../../services/study-report/study-report.service';



export class StudyReportTemplateDialogRequest {
  public PhysicianId: number;
  public StudyReportId: number;
  public EditorId: number;
}


@Component({
  selector: 'study-report-template-dialog',
  templateUrl: 'study-report-template-dialog.component.html',
  styleUrls: ['./study-report-template-dialog.component.css']
})
export class StudyReportTemplateDialogComponent implements OnInit {

  studyReportTemplateFiltersColums = ['Select', 'Name'];
  studyReportTemplateFiltersDataSource = new MatTableDataSource([]);
  templateIds: number[];
  loading: boolean;

  constructor(private studyReportService: StudyReportService
    , private notificationToastService: NotificationToastService
    , public dialogRef: MatDialogRef<StudyReportTemplateDialogComponent>
    , @Inject(MAT_DIALOG_DATA) public data: StudyReportTemplateDialogRequest) {

  }

  onNoClick(): void {
    this.dialogRef.close(null);
  }

  async save() {
    let templateTexts: string[] = [];
    if (this.templateIds.length > 0) {
      templateTexts = await this.studyReportService.getStudyReportTemplatesText(this.templateIds);
    }
    this.dialogRef.close(templateTexts);
  }

  checkChange(id: number): void {
    const index = this.templateIds.findIndex(x => x === id);
    if (index > -1) {
      this.templateIds.splice(index, 1);
    } else {
      this.templateIds.push(id);
    }
  }


  async ngOnInit() {
    try {
      this.loading = true;
      this.templateIds = [];
      const items = await this.studyReportService.getStudyReportTemplateFilters(
        this.data.PhysicianId,
        this.data.StudyReportId,
        this.data.EditorId
      );
      this.studyReportTemplateFiltersDataSource = new MatTableDataSource(items);
    } catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), 'Plantillas');
    } finally {
      this.loading = false;
    }
  }
}
